export default "__VITE_PUBLIC_ASSET__ab1c5c52__"